module.exports = __webpack_public_path__ + "img/2-prepare.a8f86262.gif";